import React from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';

import Button from '../Button/Button';
import Label from '../Labels/Label';

export const DEFAULT_CTA_LABEL = 'Getting Started'

export const BlankSlate = ({ 
  className,
  mainText,
  subText,
  onCTAClicked,
  Graphic,
  CTAInfo,
  ctaButtonLabel = DEFAULT_CTA_LABEL,
}) => {
  if (!isString(mainText) && !isString(subText) && !isFunction(Graphic) && !isFunction(CTAInfo) && !isFunction(onCTAClicked)) {
    return null;
  }
  return (
    <div className={classNames('flex flex-col items-center justify-start', className)}>
      {
        isFunction(Graphic) ? <Graphic /> : null
      }
      {
        isString(mainText) ? (
          <Label className="my-4" color="gray-600" size="2xl" bold>
            { mainText }
          </Label>
        ) : null
      }
      {
        isString(subText) ? (
          <Label className="my-4" color="gray-600" size="xl">
            { subText }
          </Label>
        ) : null
      }
      {
        isFunction(onCTAClicked) ? (
          <Button 
            variant="primary" 
            onClick={onCTAClicked}
          >
            {ctaButtonLabel}
          </Button>
        ) : null
      }
      {
        isFunction(CTAInfo) ? (
          <div className="mt-2">
            <CTAInfo />
          </div>
        )
          : null 
      }
    </div>
  )
}

export default BlankSlate;
